var _circle, _path, _path2, _path3, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentUnavailableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 107,
    height: 106,
    viewBox: "0 0 107 106",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53.404,
    cy: 52.929,
    r: 52.929,
    fill: "#E8F7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#00A3FA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.804,
    d: "M53.414 68.062a.814.814 0 1 0 0 1.629.814.814 0 0 0 0-1.629Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#00A3FA",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.804,
    d: "M53.414 61.552V45.276"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#00A3FA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.804,
    d: "M56.932 31.191a3.92 3.92 0 0 0-7.035 0l-20.558 41.88a3.3 3.3 0 0 0 2.964 4.757h42.223a3.3 3.3 0 0 0 2.964-4.757l-20.558-41.88Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.414,
    cy: 68.876,
    r: 1.167,
    fill: "#00A3FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentUnavailableIcon);
export default __webpack_public_path__ + "static/media/document-unavailable-icon.6e111b9112a3f7da592b145fe730d7b3.svg";
export { ForwardRef as ReactComponent };